/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type AccountType = "FISA" | "GIACorporate" | "GIAIndividual" | "GIAJoint" | "GIATrust" | "JISA" | "SIPP" | "%future added value";
export type ApprovableStatus = "APPROVED" | "CANCELLED" | "PENDING" | "%future added value";
export type OrderStatus = "CAN" | "CRE" | "FIL" | "INI" | "INM" | "PEX" | "PFL" | "POS" | "QUE" | "REJ" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type PortfolioOrderRequestList_viewer$ref: FragmentReference;
declare export opaque type PortfolioOrderRequestList_viewer$fragmentType: PortfolioOrderRequestList_viewer$ref;
export type PortfolioOrderRequestList_viewer = {|
  +portfolioOrderRequests: ?{|
    +count: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +status: ApprovableStatus,
        +createdAt: any,
        +createdBy: ?{|
          +id: string,
          +fullName: ?string,
        |},
        +approvals: ?{|
          +count: ?number,
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +id: string
            |}
          |}>,
        |},
        +portfolioOrder: {|
          +id: string,
          +account: {|
            +id: string,
            +name: ?string,
            +clientaccount: ?{|
              +accountType: ?AccountType
            |},
          |},
          +stockOrders: {|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +brokerOrder: ?{|
                  +status: OrderStatus
                |},
              |}
            |}>
          |},
        |},
      |}
    |}>,
  |},
  +$refType: PortfolioOrderRequestList_viewer$ref,
|};
export type PortfolioOrderRequestList_viewer$data = PortfolioOrderRequestList_viewer;
export type PortfolioOrderRequestList_viewer$key = {
  +$data?: PortfolioOrderRequestList_viewer$data,
  +$fragmentRefs: PortfolioOrderRequestList_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PortfolioOrderRequestList_viewer",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int",
      "defaultValue": 10
    },
    {
      "kind": "LocalArgument",
      "name": "offset",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "accountType",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "portfolioOrderRequests",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "accountType",
          "variableName": "accountType"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "offset",
          "variableName": "offset"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "-createdAt"
        }
      ],
      "concreteType": "PortfolioOrderRequestNodeConnection",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PortfolioOrderRequestNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "PortfolioOrderRequestNode",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "createdAt",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "createdBy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserNode",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "fullName",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "approvals",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ApprovalNodeConnection",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ApprovalNodeEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ApprovalNode",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "portfolioOrder",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PortfolioOrderNode",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "account",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "AccountNode",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "name",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "clientaccount",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ClientAccountNode",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "accountType",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "stockOrders",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "StockOrderNodeConnection",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "StockOrderNodeEdge",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "StockOrderNode",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "brokerOrder",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "BrokerOrderNode",
                                  "plural": false,
                                  "selections": [
                                    (v2/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '5093e55328feda2c5ab604d361965284';
module.exports = node;
